var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleGradientEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9231 19H18.0769C17.7913 19 17.5174 19.1003 17.3154 19.2789C17.1135 19.4576 17 19.6998 17 19.9524V28.0476C17 28.3002 17.1135 28.5424 17.3154 28.7211C17.5174 28.8997 17.7913 29 18.0769 29H29.9231C30.2087 29 30.4826 28.8997 30.6846 28.7211C30.8865 28.5424 31 28.3002 31 28.0476V19.9524C31 19.6998 30.8865 19.4576 30.6846 19.2789C30.4826 19.1003 30.2087 19 29.9231 19Z",
    stroke: "url(#paint0_linear_675_7116)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20L23.3108 23.8232C23.5046 23.9382 23.748 24 24 24C24.252 24 24.4954 23.9382 24.6892 23.8232L31 20",
    stroke: "url(#paint1_linear_675_7116)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_675_7116",
    x1: 17,
    y1: 24,
    x2: 31,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_675_7116",
    x1: 17,
    y1: 22,
    x2: 31,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGradientEmail);
export default __webpack_public_path__ + "static/media/circle-gradient-email.5cefef7cf01651c6ba011c5fbd7bfd05.svg";
export { ForwardRef as ReactComponent };